import React, { useCallback } from 'react'

import { useOnKeyDown } from '@avantstay/backoffice-core'

import { EmptyMessage } from '@new/__global/components/EmptyMessage'
import { OmniSearchStore } from '@new/__global/components/OmniSearch/OmniSearchStore'

import { IResultsTemplateProps } from '@/_new/__global/components/OmniSearch/OmniSearch.types'
import { mountRouteUrl } from '@routes'

import * as S from './ResultsTemplate.styles'

function ResultsTemplate<T>({
  activeIndex,
  data,
  enabledNavigation,
  onClick,
  renderChildren,
  setIndex,
  titlePrefix,
  baseUrl,
  queryParamKey,
  totalCount,
  searchTerm,
}: IResultsTemplateProps<T>): JSX.Element {
  const MAX_ITEMS_TO_DISPLAY = 10
  const hasViewAllLink = totalCount > MAX_ITEMS_TO_DISPLAY

  const handleOnClick = useCallback(
    (it: T) => () => {
      OmniSearchStore.setShowContainer(false)
      onClick(it)
    },
    [onClick],
  )

  const useOnKeyDownCallback = useCallback(() => {
    if (data.length !== 0 && activeIndex !== -1 && enabledNavigation) {
      handleOnClick(data[activeIndex])()
    }
  }, [activeIndex, data, enabledNavigation, handleOnClick])

  useOnKeyDown('enter', useOnKeyDownCallback)

  return (
    <>
      {data.length === 0 && <EmptyMessage>No {titlePrefix} found :(</EmptyMessage>}

      {data.slice(0, MAX_ITEMS_TO_DISPLAY).map((it, key) => (
        <S.Item
          key={`omni-search-result-${key}`}
          isFocused={activeIndex === key && enabledNavigation}
          onClick={handleOnClick(it)}
          onMouseEnter={() => setIndex(-1)}
        >
          {renderChildren(it)}
        </S.Item>
      ))}

      {hasViewAllLink && (
        <S.ViewAll to={mountRouteUrl(baseUrl, undefined, { [queryParamKey]: `${searchTerm}` })}>
          View All
        </S.ViewAll>
      )}
    </>
  )
}

export default ResultsTemplate
